import DOMPurify from 'dompurify';

/**
 * sanitize - Strip all HTML tags from a string to prevent XSS.
 *
 * Use this on every user-generated or database-sourced string that is
 * rendered directly into JSX text content. Returns a safe plain-text
 * string — no HTML tags will survive.
 *
 * ALLOWED_TAGS: [] means zero tags are permitted, so even innocuous
 * tags like <b> are stripped. This is intentional: we render talking
 * points and summaries as plain text, not HTML.
 *
 * @param {string|null|undefined} str - The value to sanitize
 * @returns {string} Safe plain-text string (empty string if falsy input)
 */
export const sanitize = (str) => {
  if (!str) return '';
  return DOMPurify.sanitize(str, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
};
